type AnyObject = Record<string, any>

export function camelToSnake(key: string): string {
    return key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export function convertKeysToSnakeCase(obj: AnyObject): AnyObject {
    if (Array.isArray(obj)) {
        return obj.map((item) => convertKeysToSnakeCase(item))
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const snakeKey = camelToSnake(key)
            acc[snakeKey] = convertKeysToSnakeCase(obj[key])
            return acc
        }, {} as AnyObject)
    }
    return obj
}

export function getPageName() {
    if (typeof window === 'undefined') {
        return ''
    }
    const { pathname } = window.location

    // Homepage
    if (pathname === '/') {
        return 'homepage'
    }
    // page-container
    // Search result: All jobs
    if (pathname === '/tim-viec-lam/tim-tat-ca-viec-lam' || pathname === '/job-search/all-jobs') {
        return 'search_results'
    }
    // multiple-job-apply
    if (pathname.match(/^\/ung-tuyen-nhieu-viec-lam/) || pathname.match(/^\/apply-multiple-jobs/)) {
        return 'multiple_job_apply'
    }
    // career-center-container
    if (pathname === '/quan-ly-nghe-nghiep/thong-bao-viec-lam' || pathname === '/my-career-center/my-job-alert') {
        return 'my_job_alert'
    }
    // career-center-container
    if (pathname === '/quan-ly-nghe-nghiep/viec-lam-cua-toi' || pathname === '/my-career-center/my-jobs') {
        return 'my_jobs'
    }
    // career-center-container
    if (pathname === '/quan-ly-nghe-nghiep/cong-ty-cua-toi' || pathname === '/my-career-center/my-companies') {
        return 'my_companies'
    }
    // page-container
    // Search result: filtered jobs
    if (pathname.indexOf('-en') >= 1 && pathname.indexOf('-vn') >= 1) {
        return 'search_results'
    }
    // wealth-container
    if (pathname.match(/^\/muc-luong/) || pathname.match(/^\/salary/)) {
        return 'landing_career_salary'
    }
    // wealth-container
    // Interview Page
    if (pathname.match(/^\/cau-hoi-phong-van/) || pathname.match(/^\/interview/)) {
        return 'interview_page'
    }
    // wow-cv-container
    if (pathname === '/wowcv/en' || pathname === '/wowcv') {
        return 'wow_cv'
    }
    // new-wowcv-container
    if (pathname === '/preview-cv' || pathname === '/xem-truoc') {
        return 'new_wow_cv'
    }
    // marketing-landing-container
    // intech
    if (pathname === '/intech') {
        return 'intech_page'
    }
    // landing-page-container
    // career-newbies
    if (pathname === '/career-newbies') {
        return 'career_newbies'
    }
    // landing-page-container
    if (pathname === '/job-search' || pathname === '/tim-viec-lam') {
        return 'landing_job_search'
    }
    // landing-page-container
    if (pathname.match(/^\/lo-trinh-su-nghiep/) || pathname.match(/^\/career-path/)) {
        return 'landing_career_path'
    }
    // landing-page-container
    if (pathname === '/nhan-so-hoc' || pathname === '/numberology') {
        return 'numerology'
    }
    // landing-page-container
    if (pathname.match(/\/so-chu-dao/) || pathname.match(/\/ruling-number/)) {
        return 'numerology_ruling_number'
    }
    // companyprofile
    if (pathname.indexOf('/company/') >= 0) {
        return 'company_culture_profile'
    }
    // company-container
    if (pathname.match(/\/nha-tuyen-dung/) || pathname.match(/\/companies/)) {
        return 'company_profile'
    }
    // company-container
    if (pathname === '/danh-sach-cong-ty' || pathname === '/company-list') {
        return 'company_profile'
    }
    // job-details
    if (window.location.pathname.match(/\d{6}(-jd|-jv)/)) {
        return 'job_detail'
    }
    // page-container
    if (pathname.match(/\/viec-lam-quan-ly|\/management-jobs/)) {
        return 'search_results'
    }
    // page-container
    if (pathname.match(/-kv|-kw|-i\d{2}|-v\d{2}|jobs|all-jobs|viec-lam|tat-ca-viec-lam|e\d{7}-vn|e\d{7}-en/gi)) {
        return 'search_results'
    }
    // landing-page-container Onboarding
    if (pathname.match(/\/onboarding|\/chao-don-ung-vien-moi/)) {
        return 'onboarding_page'
    }
    // sso
    if (pathname.match(/\/login\/vi|\/login\/en/)) {
        return 'sso'
    }
    // career-center-container
    if (pathname.match(/\/my-career-center|\/quan-ly-nghe-nghiep/)) {
        return 'my_career_center'
    }
    // career-center-container
    if (pathname === '/quan-ly-tai-khoan' || pathname === '/account-settings') {
        return 'account_settings'
    }
    // career-center-container
    if (pathname === '/ho-so' || pathname === '/my-profile') {
        return 'my_profile'
    }
    // vietnamworks
    if (pathname === '/logout' || pathname === '/thoat') {
        return 'logout'
    }

    if (
        pathname === '/welcome/start' ||
        pathname === '/chao-mung/bat-dau' ||
        pathname === '/welcome/create-profile' ||
        pathname === '/chao-mung/tao-ho-so' ||
        pathname === '/welcome/work-info' ||
        pathname === '/chao-mung/nghe-nghiep' ||
        pathname === '/welcome/skills' ||
        pathname === '/chao-mung/ky-nang' ||
        pathname === '/welcome/experience' ||
        pathname === '/chao-mung/kinh-nghiem' ||
        pathname === '/welcome/contact' ||
        pathname === '/chao-mung/lien-he' ||
        pathname === '/welcome/basic' ||
        pathname === '/chao-mung/co-ban' ||
        pathname === '/welcome/preference' ||
        pathname === '/chao-mung/mong-muon'
    ) {
        return 'new-onboarding'
    }

    return pathname
}

export async function delay(ms: number = 0) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export function generateUuidV4(): string {
    // Replace x and y in the template with random hexadecimal digits
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0
        // Ensures the 4 and y positions follow the UUIDv4 spec
        const value = char === 'x' ? random : (random & 0x3) | 0x8

        return value.toString(16)
    })
}
